import { useEffect, useState } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window
  return {
    width,
    height,
  }
}
const MobileViewHandler: React.FC = () => {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions())
  const location = useLocation()

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions())
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  })

  if (windowDimensions?.width < 1024 && location?.pathname !== '/mobileWarningPage') {
    return <Navigate to='/mobileWarningPage' />
  }

  return windowDimensions?.width >= 1024 && location?.pathname === '/mobileWarningPage' ? (
    <Navigate to='/' />
  ) : (
    <Outlet />
  )
}

export default MobileViewHandler
